import { Divider, styled } from "@mui/material";

export const StyledDivider = styled(Divider)(({ theme }) => ({
  marginTop: "16px",
  marginBottom: "24px",
  borderColor: theme.palette.grey[300],
}));
